var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-value area"
  }, [_c("section", {
    staticClass: "product-value__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("VALUE")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("产品价值")])]), _c("section", {
    staticClass: "product-value__contrast"
  })]);
}];
render._withStripped = true;
export { render, staticRenderFns };